import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, Fragment as _Fragment, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gradient-to-br from-dashboard-bg via-white to-dashboard-bg flex items-center justify-center p-4 sm:p-6" }
const _hoisted_2 = { class: "w-full max-w-md" }
const _hoisted_3 = { class: "bg-white border border-dashboard-border rounded-xl sm:rounded-2xl shadow-xl p-5 sm:p-6 md:p-8" }
const _hoisted_4 = {
  key: 0,
  class: "mb-4 sm:mb-6 p-3 sm:p-4 bg-red-50 border border-red-200 rounded-lg flex items-start gap-2 sm:gap-3"
}
const _hoisted_5 = { class: "text-xs sm:text-sm text-red-800 break-words" }
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = ["type"]
const _hoisted_9 = { class: "flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-0" }
const _hoisted_10 = { class: "flex items-center gap-2 cursor-pointer group" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { key: 1 }

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { Eye, EyeOff, Lock, Mail, AlertCircle } from 'lucide-vue-next'
import { useAuthStore } from '@/store/auth'


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const router = useRouter()
const { login } = useAuthStore()

const username = ref('')
const password = ref('')
const showPassword = ref(false)
const rememberMe = ref(false)
const isLoading = ref(false)
const error = ref('')

const handleSubmit = async () => {
  error.value = ''
  isLoading.value = true

  try {
    const result = await login(username.value, password.value)

    switch (result.status) {
      case 'success':
        if (rememberMe.value) localStorage.setItem('rememberMe', 'true')
        router.push('/dashboard')
        break
      case 'otp_required':
        // 2FA active : saisir le code de l'application d'authentification
        router.push('/otp')
        break
      case 'setup_required':
        // 2FA obligatoire non configurée : afficher le QR code
        router.push('/setup-2fa')
        break
      default:
        error.value = result.error || 'Identifiants incorrects'
    }
  } catch (e) {
    error.value = 'Erreur de connexion au serveur'
  } finally {
    isLoading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "text-center mb-6 sm:mb-8" }, [
        _createElementVNode("div", { class: "flex justify-center mb-4 sm:mb-6" }, [
          _createElementVNode("img", {
            src: "/logo.png",
            alt: "Logo",
            class: "h-16 sm:h-20 md:h-24 w-auto object-contain"
          })
        ]),
        _createElementVNode("p", { class: "text-dashboard-muted text-sm sm:text-base md:text-lg px-4" }, " Gestion Électronique des Courriers Diplomatiques ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "text-xl sm:text-2xl font-bold text-dashboard-text mb-1 sm:mb-2 text-center" }, "Connexion", -1)),
        _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-dashboard-muted text-sm sm:text-base mb-4 sm:mb-6 text-center" }, " Accédez à votre espace de travail ", -1)),
        (error.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_unref(AlertCircle), { class: "w-4 h-4 sm:w-5 sm:h-5 text-red-600 flex-shrink-0 mt-0.5" }),
              _createElementVNode("p", _hoisted_5, _toDisplayString(error.value), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("form", {
          onSubmit: _withModifiers(handleSubmit, ["prevent"]),
          class: "space-y-4 sm:space-y-6"
        }, [
          _createElementVNode("div", null, [
            _cache[4] || (_cache[4] = _createElementVNode("label", {
              for: "username",
              class: "block text-xs sm:text-sm font-medium text-dashboard-text mb-1.5 sm:mb-2"
            }, " Nom d'utilisateur ", -1)),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(Mail), { class: "absolute left-3 sm:left-4 top-1/2 -translate-y-1/2 w-4 h-4 sm:w-5 sm:h-5 text-dashboard-muted" }),
              _withDirectives(_createElementVNode("input", {
                id: "username",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event)),
                type: "text",
                placeholder: "votre username",
                class: "w-full pl-10 sm:pl-12 pr-3 sm:pr-4 py-2.5 sm:py-3 bg-dashboard-bg border border-dashboard-border rounded-lg text-sm sm:text-base text-dashboard-text placeholder:text-dashboard-muted focus:outline-none focus:border-dashboard-accent focus:ring-2 focus:ring-dashboard-accent/20 transition-all",
                required: ""
              }, null, 512), [
                [_vModelText, username.value]
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[5] || (_cache[5] = _createElementVNode("label", {
              for: "password",
              class: "block text-xs sm:text-sm font-medium text-dashboard-text mb-1.5 sm:mb-2"
            }, " Mot de passe ", -1)),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_unref(Lock), { class: "absolute left-3 sm:left-4 top-1/2 -translate-y-1/2 w-4 h-4 sm:w-5 sm:h-5 text-dashboard-muted" }),
              _withDirectives(_createElementVNode("input", {
                id: "password",
                type: showPassword.value ? 'text' : 'password',
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                placeholder: "••••••••",
                class: "w-full pl-10 sm:pl-12 pr-10 sm:pr-12 py-2.5 sm:py-3 bg-dashboard-bg border border-dashboard-border rounded-lg text-sm sm:text-base text-dashboard-text placeholder:text-dashboard-muted focus:outline-none focus:border-dashboard-accent focus:ring-2 focus:ring-dashboard-accent/20 transition-all",
                required: ""
              }, null, 8, _hoisted_8), [
                [_vModelDynamic, password.value]
              ]),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (showPassword.value = !showPassword.value)),
                class: "absolute right-3 sm:right-4 top-1/2 -translate-y-1/2 text-dashboard-muted hover:text-dashboard-text transition-colors"
              }, [
                (showPassword.value)
                  ? (_openBlock(), _createBlock(_unref(EyeOff), {
                      key: 0,
                      class: "w-4 h-4 sm:w-5 sm:h-5"
                    }))
                  : (_openBlock(), _createBlock(_unref(Eye), {
                      key: 1,
                      class: "w-4 h-4 sm:w-5 sm:h-5"
                    }))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((rememberMe).value = $event)),
                class: "w-4 h-4 text-dashboard-accent border-dashboard-border rounded focus:ring-2 focus:ring-dashboard-accent/20 cursor-pointer"
              }, null, 512), [
                [_vModelCheckbox, rememberMe.value]
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-xs sm:text-sm text-dashboard-text group-hover:text-dashboard-accent transition-colors whitespace-nowrap" }, " Se souvenir de moi ", -1))
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("button", {
              type: "button",
              class: "text-xs sm:text-sm text-dashboard-accent hover:underline font-medium whitespace-nowrap"
            }, " Mot de passe oublié ? ", -1))
          ]),
          _createElementVNode("button", {
            type: "submit",
            disabled: isLoading.value,
            class: "w-full py-2.5 sm:py-3 bg-[#22282F] text-white rounded-lg text-sm sm:text-base font-medium hover:bg-[#22282F] focus:outline-none focus:ring-2 focus:ring-dashboard-accent/20 transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          }, [
            (isLoading.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "w-4 h-4 sm:w-5 sm:h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" }, null, -1)),
                  _cache[9] || (_cache[9] = _createElementVNode("span", null, "Connexion en cours...", -1))
                ], 64))
              : (_openBlock(), _createElementBlock("span", _hoisted_12, "Se connecter"))
          ], 8, _hoisted_11)
        ], 32),
        _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"relative my-4 sm:my-6\"><div class=\"absolute inset-0 flex items-center\"><div class=\"w-full border-t border-dashboard-border\"></div></div><div class=\"relative flex justify-center text-xs sm:text-sm\"><span class=\"px-3 sm:px-4 bg-white text-dashboard-muted\">Ou</span></div></div><button type=\"button\" class=\"w-full py-2.5 sm:py-3 bg-white border-2 border-dashboard-border text-dashboard-text rounded-lg text-sm sm:text-base font-medium hover:bg-dashboard-bg transition-all flex items-center justify-center gap-2\"><svg class=\"w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0\" viewBox=\"0 0 24 24\"><path fill=\"currentColor\" d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z\"></path></svg><span>Se connecter avec SSO</span></button>", 2))
      ]),
      _cache[14] || (_cache[14] = _createStaticVNode("<div class=\"mt-4 sm:mt-6 text-center px-4\"><p class=\"text-xs sm:text-sm text-dashboard-muted\"> Vous n&#39;avez pas de compte ? <button class=\"text-dashboard-accent hover:underline font-medium\">Contactez le support</button></p></div><div class=\"mt-6 sm:mt-8 text-center\"><p class=\"text-xs text-dashboard-muted\">v1.0 • © 2025 Ministère des Affaires Étrangères</p></div>", 2))
    ])
  ]))
}
}

})